import {postData,getData,deleteData,jsonpData} from './request'
const previewUrl = 'https://preview.wps.com/preview/getWebDocview'
const historyPreviewUrl = 'https://preview.wps.com/preview/getHistoryDocview'
// 获取预览文件信息
export function meta({fileid,historyid}, cb) {
  let url = historyid ? `/api/v3/files/${fileid}/historyinfo?version=${historyid}` : `/api/files/${fileid}/metadata?recycle=false&openfile=1&_=${(new Date()).getTime()}`
  return getData(url, {}, cb)
}

// 获取当前文件事件
export function events({fileid,offset,count,groupid}, cb) {
  return getData(`/api/v3/files/${fileid}/events?offset=${offset}&count=${count}&groupid=${groupid}`, {}, cb)
}

// 评论
export function comment(paload, cb) {
	let url = `/api/v3/files/${paload.fileid}/comments`
	delete paload.fileid
	return postData(url, paload,{}, cb)
}

// 删除评论
export function deleteComment(paload,cb){
	return deleteData(`/api/v3/files/${paload.fileid}/comments`,paload,{},cb)
}

// 获取分享预览地址
export function getView({timestamp,fileid,historyid,groupid},cb){
  let url = historyid ? `${historyPreviewUrl}?canvas=true&timestamp=${timestamp}&newstart=1&fileid=${fileid}&historyid=${historyid}&groupid=${groupid}&recycle=false&complex=false` :
            `${previewUrl}?canvas=true&timestamp=${timestamp}&newstart=1&fileid=${fileid}&recycle=false&complex=false`
  return jsonpData(url, {
  },cb)
}

// 加入最近列表
export function createRecent(paload, cb) {
  return postData(`/api/v4/createroam`, paload, {}, cb)
}

// 获取weboffice预览地址
export function getWO({fileid,groupid,version,historyid}, cb) {
  return getData(`/api/view/link?fileid=${fileid}&groupid=${groupid}${historyid ? `&version=${version}` : ''}`, {}, cb)
}


// WEBPACK FOOTER //
// ./src/store/service/preview.js